import React, {useState,useEffect} from "react";
import {Form, Formik} from "formik";
import * as Yup from "yup";
import {BlockUnsavedForm} from "../BlockUnsavedForm/BlockUnsavedForm";
import {ControlDetailInfo} from "../ControlDetailInfo/ControlDetailInfo";
import {
    CreateNoteAttachments
} from '../CreateNoteAttachments/CreateNoteAttachments';
import {serializeAttachmentsForSaving} from '../documents/helpers';
import {FormActionButtons} from "../FormActionButtons/FormActionButtons";
import {unblockRoute} from "../../Services/BlockChangeRoute";
import {isWTrakcieRealizacji} from "../ControlStateHelper";
import {generatePostControlNoteDocx} from '../DocxTemplate/PostControlNoteDocx';
import { createPdf } from "../PostControlNoteDetail/PostControlNoteDetail";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import {PDFDownloadLink} from '@react-pdf/renderer';
import WysiwygEditor from '../WysiwygEditor/WysiwygEditor';
import {getContentLength} from '../WysiwygEditor/WysiwygHelpers'

const validateNoteContent = Yup.string()
    .test(
        'characterCount',
        'Treść notatki nie może być dłuższa niż 4000 znaków',
        function(value) {
            if (value) {
              const editorCharsLength = getContentLength(value);

                return editorCharsLength <= 4000;
            }
            return true;
        }
    )
    .required("Uzupełnij pole treść notatki");

export const FormSchema = Yup.object().shape({
  noteContent: validateNoteContent,
});
    

export const PostControlForm = (props) => {
  const [noteValue, setNoteValue] = useState(props.noteContent);
  const [attachments, setAttachments] = useState(props.attachments);

  useEffect(() => {
        setAttachments(props.attachments || []);
  }, [props.attachments]);

  return (
    <Formik
      enableReinitialize={true}
      initialValues={{
        noteContent: noteValue || '',
      }}
      validationSchema={FormSchema}
      onSubmit={(values) => {
        unblockRoute();
        props.handleSaveNote({
          ...values,
          attachments: serializeAttachmentsForSaving(attachments, true),
        });
      }}
    >
      {({ values, errors }) => {
        const noteNumber = `${props.control.number}-NOT`;
        const fileName = `eKontrole-${noteNumber}.pdf`;
        
        return (
          <>
            <BlockUnsavedForm />

            <Form>
              <button type='button' onClick={() => {
                generatePostControlNoteDocx(props)
              }} className='doc-button'>
                <img
                  className='ico-doc'
                  src='/icoDoc.svg'
                  alt='Pobierz dokument .docx'
                />
              </button>
              <PDFDownloadLink document={createPdf(props.control, props.noteData, noteNumber)} fileName={fileName}>
                  <PictureAsPdfIcon style={{ color: '#0d47a1', fontSize: 46, marginLeft: 10 }} />
                  <span className="sr-only">Kliknij, aby pobrać PDF</span>
              </PDFDownloadLink>
              <div className='btn_group my-1'>
                  {isWTrakcieRealizacji(props.control) && <span className='red h5'>WERSJA ROBOCZA</span>}
                <button
                  className='btn cancel-btn'
                  type='button'
                  onClick={props.onDeleteButtonClick}
                >
                  USUŃ
                </button>
              </div>
              <h3>
                <span className='titleClass'>Notatka pokontrolna </span>
                <span className='font-weight-bold'>
                  {props.control.number + "-NOT"}
                </span>
              </h3>

              <ControlDetailInfo control={props.control} />

              <div className='controlListBlocks'>
                <h4 className="mt-4">Treść notatki</h4>
                <WysiwygEditor
                  name='noteContent'
                  size={4000}
                  value={noteValue}
                  onChange={(e) => {setNoteValue(e.target.value); props.handleShortChange(e.target.value)}}
                  errorId='noteAlert'
                  error={errors.noteContent}
                />
				      </div>

              <div className='controlListBlocks'>
                <h4 className='mt-4'>Załączniki:</h4>
                <CreateNoteAttachments
                  attachments={attachments}
                  controlUuid={props.control.uuid}
                  projectUuid={props.control.project.metadata.uuid}
                  setAttachments={attachments => setAttachments(attachments)}
                />
              </div>

              <FormActionButtons
                abortPath={`/my_controls/active?number=${props.control.number}`}
              />
            </Form>
          </>
        );
      }}
    </Formik>
  );
};
